/* built-in imports */
import React from 'react';
import { connect } from 'react-redux';

/* Internal imports */
import FinalisationAttachmentsForm from './FinalisationAttachmentsForm';
import componentUtils from '../../../../../utils/US/components/epargne_salariale/forms/finalisationAttachmentsFormUtils';
import { TYPE_DOCUMENT } from '../../../../../common/Configuration';
import { FORMES_JURIDIQUES } from '../../../../../utils/constantes/US/FINALISATION_FORM';

const EpargneInformationsAttachmentsFormSociete = (
  {
    annexeKyc,
    enterpriseConsulting,
    justificatifIdentiteEntreprise,
    planExistant,
    tradKey
  }) => {

  const documents = componentUtils.filterDocuments(planExistant, annexeKyc, FORMES_JURIDIQUES.SOCIETE.key);

  const getSpecificFilesData = () => {
    const filesData = {};
    const allDocuments = Array.prototype.concat(documents.required, documents.optional);
    for(let i = 0, documentsLength = allDocuments.length; i < documentsLength; i++) {
      const document = allDocuments[i];
      let fileData;
      switch (document.type) {
        case TYPE_DOCUMENT.CONSULTATION_ENTREPRISE:
          fileData = componentUtils.getFile(enterpriseConsulting);
          break;
        case TYPE_DOCUMENT.JUSTIFICATIF_IDENTITE_ENTREPRISE:
          fileData = componentUtils.getFile(justificatifIdentiteEntreprise);
          break;
        default:
          continue;
      }
      filesData[document.key] = fileData;
    }
    return filesData;
  };

  return (
    <FinalisationAttachmentsForm documents={documents} getSpecificFilesData={getSpecificFilesData} tradKey={tradKey} />
  );
};

const mapStateToProps = (state) => ({
  annexeKyc: state.tunnel.dossier.donneesAnnexeKYC,
  enterpriseConsulting: state.tunnel.dossier.consultationEntreprise,
  justificatifIdentiteEntreprise: state.tunnel.entreprise.justificatifIdentiteEntreprise,
  planExistant: state.tunnel.dossier.planExistant
});

export default connect(mapStateToProps)(EpargneInformationsAttachmentsFormSociete);